import clsx from 'clsx';

interface BaseToggleSwitchProps {
  name: string;
  label?: string;
  disabled?: boolean;
  value: boolean;
  onChange: (checked: boolean) => void;
  errorMessage?: string;
  className?: string;
  style?: React.CSSProperties;
  [key: string]: any;
}

export default function BaseToggleSwitch({
  name,
  label,
  disabled = false,
  value,
  onChange,
  errorMessage = '',
  className,
  classNameWrapper,
  style,
  ...props
}: BaseToggleSwitchProps) {
  return (
    <div
      className={clsx('mb-0', { 'opacity-40 pointer-events-none': disabled }, classNameWrapper || className)}
      style={style}
    >
      <label className="inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          name={name}
          className="sr-only peer"
          disabled={disabled}
          checked={!!value}
          onChange={(e) => onChange(e.target.checked)}
          {...props}
        />
        <div
          className={clsx(
            'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2',
            value ? 'bg-brand-500' : 'bg-gray-200 dark:bg-gray-700',
            {
              'ring-2 ring-red-500 ring-offset-2': errorMessage !== '',
            }
          )}
        >
          <span
            aria-hidden="true"
            className={clsx(
              'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-md ring-0 transition duration-200 ease-in-out',
              value ? 'translate-x-5' : 'translate-x-0'
            )}
          />
        </div>
        {label && (
          <span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">{label}</span>
        )}
      </label>
      {errorMessage && <p className="text-red-500 text-sm mt-1">{errorMessage}</p>}
    </div>
  );
}
